import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';
// import IconHome from '../assets/images/new-ui/icon/icon_home.svg';
import IconYuanshuju from '../assets/images/new-ui/icon/icon_yuanshuju.svg';
// import IconLiulanshuju from '../assets/images/new-ui/icon/icon_liulanshuju.svg';
import IconHuoquchanpin from '../assets/images/new-ui/icon/icon_huoquchanpin.svg';
import IconXiazairuanjian from '../assets/images/new-ui/icon/icon_xiazairuanjian.svg';
import IconDashujukeshi from '../assets/images/new-ui/icon/icon_dashujukeshi.svg';
import IconStations from '../assets/images/new-ui/icon/icon_stations.svg';
import IconXiangmufuwu from '../assets/images/new-ui/icon/icon_xiangmufuwu.svg';
import IconZhuanjingtexin from '../assets/images/new-ui/icon/icon_zhuanjingtexin.svg';
import IconHuijiaofuwu from '../assets/images/new-ui/icon/icon_huijiaofuwu.svg';
import IconZhongxindongtai from '../assets/images/new-ui/icon/icon_zhongxindongtai.svg';
import IconChakantuji from '../assets/images/new-ui/icon/icon_chakantuji.svg';
// import IconPopularScience from '../assets/images/new-ui/icon/icon_popular_science.svg';
// import IconKnowledgeGraph from '../assets/images/new-ui/icon/icon_knowledge_graph.svg';
import IconBuoy from '../assets/images/new-ui/icon/icon_buoy.svg';
import IconVirtualMarket from '../assets/images/new-ui/icon/icon_virtualmarket.svg';

Vue.use(Vuex);

const state = {
  currentMenu: {},
  userInfo: {},
  currentOpenMenu: '',
  showSideNav: true,
  dictionary: {},
  menuList: [
    // { icon: IconHome, title: 'home', url: '/' },
    { icon: IconYuanshuju, title: 'metaData', url: '/metaData-list' },
    // { icon: IconLiulanshuju, title: 'browseData', url: '/browse-data' },
    { icon: IconChakantuji, title: 'boutiqueImages', url: '/boutique-images-list' },
    { icon: IconHuoquchanpin, title: 'accessProducts', url: '/products-list' },
    { icon: IconXiazairuanjian, title: 'downloadSoftware', url: '/software-list' },
    // { icon: IconDashujukeshi, title: 'bigDataVisualization', url: '/big-data-headFull' },
    { icon: IconStations, title: 'stations', url: '/station-observation-list' },
    { icon: IconBuoy, title: 'buoySubmarine', url: '/buoy-submarine-list' },
    { icon: IconZhongxindongtai, title: 'voyageSurveyNetwork', url: '/voyage-geophysics-list' },
    { icon: IconXiangmufuwu, title: 'projectServices', url: '/projectServices-list' },
    { icon: IconZhuanjingtexin, title: 'thematicSelectedCharacteristicHotspot', url: '/thematic-selected-characteristic-hotspot' },
    { icon: IconHuijiaofuwu, title: 'dataExchangeService', url: '/dataExchangeService' },
    { icon: IconDashujukeshi, title: 'dataCatalogService', url: '/dataCatalog' },
    // { icon: IconZhongxindongtai, title: 'news', url: '/news-list' },
    // { icon: IconPopularScience, title: 'popularScience', url: '/popular-science-list' },
    /* { icon: IconKnowledgeGraph,
      title: 'knowledgeGraph',
      url: '/x-area',
    }, */
    { icon: IconVirtualMarket,
      title: 'dataCenter',
      url: '/virtual-trading',
    },
  ],
  globalEnumCollection: {
    spatialLocationEnumCHN: {
      1: '大气圈',
      2: '水圈',
      3: '生物圈',
      4: '地圈',
      5: '土壤圈',
      6: '全球海洋',
      7: '亚印太交汇区',
      8: '太平洋',
      9: '西太平洋',
      10: '北太平洋',
      11: '西北太平洋',
      12: '全国海洋',
      13: '中国近海及邻近海域',
      14: '中国近海',
      15: '渤黄东海',
      16: '大陆架',
      17: '海岸带',
      18: '海岸带和海涂',
      19: '潮间带',
      20: '海湾',
      21: '河口',
      22: '海岛',
      23: '南海',
      24: '巴士海峡',
      25: '巴林塘海峡',
      26: '南海东北部',
      27: '台湾西部海区',
      28: '粤东海区',
      29: '大亚湾',
      30: '汕头湾',
      31: '南海西北部',
      32: '珠江口',
      33: '粤西海区',
      34: '湛江湾',
      35: '三亚湾',
      36: '琼州海峡',
      37: '北部湾',
      38: '中越共同渔区',
      39: '南海中西部',
      40: '西沙海区',
      41: '南海中东部',
      42: '东沙南部海区',
      43: '中沙群岛附近海域',
      44: '黄岩岛附近海域',
      45: '南海东南部',
      46: '南沙群岛附近海域',
      47: '南海西南部',
      48: '曾母暗沙附近海域',
      49: '东海',
      50: '台湾海峡',
      51: '杭州湾',
      52: '长江口',
      53: '黄海',
      54: '渤海',
      55: '渤海海峡',
      56: '辽东湾',
      57: '渤海湾',
      58: '莱州湾',
      59: '海州湾',
      60: '菲律宾海',
      61: '苏禄海',
      62: '苏拉威西海',
      63: '爪哇海',
      64: '班达海',
      65: '卡里马塔海峡',
      66: '马六甲海峡',
      67: '望加锡海峡',
      68: '泰国湾',
      69: '印度洋',
      70: '东印度洋',
      71: '安达曼海',
      72: '孟加拉湾',
      73: '阿拉伯海',
      74: '斯里兰卡附近海域',
    },
    spatialLocationEnumENG: {
      1: 'Atmosphere',
      2: 'Hydrosphere',
      3: 'Biosphere',
      4: 'Geosphere',
      5: 'Pedosphere',
      6: 'Global',
      7: 'Indo-Pacific Convergence Zone',
      8: 'Pacific Ocean',
      9: 'Western Pacific Ocean',
      10: 'North Pacific Ocean',
      11: 'NW Pacific Ocean',
      12: 'China',
      13: 'China\'s Coastal Seas and Adjacent Waters',
      14: 'China\'s Coastal Seas',
      15: 'Bohai, Yellow, and East China Seas',
      16: 'Continental Shelf',
      17: 'Coastal Zone',
      18: 'Coastal Zone and Tidal Flats',
      19: 'Intertidal Zone',
      20: 'Bay',
      21: 'Estuary',
      22: 'Island',
      23: 'South China Sea',
      24: 'Bashi Channel',
      25: 'Balintang Channel',
      26: 'NE South China Sea',
      27: 'Western Taiwan Sea Area',
      28: 'Eastern Guangdong Sea Area',
      29: 'Daya Bay',
      30: 'Shantou Bay',
      31: 'NW South China Sea',
      32: 'Pearl River Estuary',
      33: 'Western Guangdong Sea Area',
      34: 'Zhanjiang Bay',
      35: 'Sanya Bay',
      36: 'Qiongzhou Haixia',
      37: 'Beibu Gulf',
      38: 'China-Vietnam Collective Fishery Zone',
      39: 'Central and Western South China Sea',
      40: 'Xisha Islands and its adjacent area',
      41: 'Central and Eastern South China Sea',
      42: 'Southern Dongsha Islands',
      43: 'Zhongsha Islands and its adjacent area',
      44: 'Huangyan Dao and its adjacent area',
      45: 'SE South China Sea',
      46: 'Nansha Islands and its adjacent area',
      47: 'SW South China Sea',
      48: 'Zengmu Shoals and its adjacent area',
      49: 'East China Sea',
      50: 'Taiwan Strait',
      51: 'Hangzhou Wan',
      52: 'Yangtze River Estuary',
      53: 'Yellow Sea',
      54: 'Bohai Sea',
      55: 'Bohai Haixia',
      56: 'Liaodong Wan',
      57: 'Bohai Wan',
      58: 'Laizhou Wan',
      59: 'Haizhou Wan',
      60: 'Philippine Sea',
      61: 'Sulu Sea',
      62: 'Celebes Sea',
      63: 'Java Sea',
      64: 'Banda Sea',
      65: 'Karimata Strait',
      66: 'Malacca Strait',
      67: 'Makassar Strait',
      68: 'Gulf of Thailand',
      69: 'Indian Ocean',
      70: 'Eastern Indian Ocean',
      71: 'Andaman of Burma Sea',
      72: 'Bay of Bengal',
      73: 'Arabian Sea',
      74: 'Sri Lanka and its adjacent area',
    },
  },
  currentProjectId: localStorage.getItem('CURRENT_PROJECT_ID') || '',
  authUrlList: {},
  superTenantId: '1',
  lang: localStorage.lang || 'CHN',
  dataCartList: [],
  registerKey: 'WebUserRegister!',
  xArea: null,
  cloudValue: null,
  chartColors: ['#19B6DB', '#0393FF', '#2075B5', '#2C908A', '#64BD9D', '#3D8DB0', '#5070E0', '#6C80B2', '#85CFC2', '#71A4D3', '#258E30', '#879AFF', '#4A758D',
    '#3453FB', '#4A8CC8', '#207E45', '#62BACE', '#2B78EB', '#6BAA81', '#4766D1', '#34C5AB', '#2A818D', '#1A93C6', '#88E0DA'],
};

export default new Vuex.Store({
  state,
  actions,
  mutations,
  getters,
  strict: process.env.NODE_ENV !== 'production',
});



// WEBPACK FOOTER //
// ./src/store/index.js